import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var blue = designTokens.color.blue.default.value;
var red = designTokens.color.red.default.value;
var black = designTokens.color.shade.black.value;
var themeOptions = function () { return ({
    components: {
        MuiListItem: {
            styleOverrides: {
                root: {
                    fontFamily: designTokens.typography.family.value,
                    cursor: 'pointer',
                    borderRadius: '4px',
                    outline: 'none',
                    '&.hyperlink': {
                        '&:hover': {
                            background: "".concat(blue, "0C"),
                        },
                        '&:active': {
                            background: "".concat(blue, "19"),
                        },
                        '&:focus': {
                            boxShadow: " inset 0 0 0 1px ".concat(blue),
                        },
                        color: "".concat(blue),
                    },
                    '&.destructive': {
                        '&:hover': {
                            background: "".concat(red, "0C"),
                        },
                        '&:active': {
                            background: "".concat(red, "19"),
                        },
                        '&:focus': {
                            boxShadow: " inset 0 0 0 1px ".concat(red),
                        },
                        color: "".concat(red),
                    },
                    '&.default': {
                        color: "".concat(black),
                        '&:hover': {
                            background: "".concat(blue, "0C"),
                            color: "".concat(blue),
                        },
                        '&:active': {
                            background: "".concat(blue, "19"),
                            color: "".concat(blue),
                        },
                        '&:focus': {
                            boxShadow: " inset 0 0 0 1px ".concat(blue),
                        },
                    },
                },
            },
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=listItemTheme.js.map